import React from 'react';

import { createColumnHelper } from '@tanstack/react-table';
import _ from 'lodash'

import ExtraActionsFormatter from '../components/Table/ExtraActionsFormatter';
import { Actions, BooleanFormatter, DeleteEntity, DuplicateEntity, DuplicateEntityWithName, EditEntity, keyOf, Toggle } from '../components/Table/formatters';

const column = createColumnHelper();

export function toggleFormatter(info) {
  return <Toggle key={keyOf(info)} info={info} />
}

export function booleanFormatter(info) {
  return <BooleanFormatter info={info} />
}

export function actions(...formatters) {
  return info => <Actions formatters={formatters} info={info} />
}

export function extraActions(...actionsList) {
  return info => <ExtraActionsFormatter key={keyOf(info, 'extra-actions')} items={actionsList.map(fn => React.cloneElement(fn(info), { asLabel: true }))} />
}

export function editAction(info) {
  return <EditEntity key={keyOf(info, 'edit')} info={info} />
}

export function deleteAction(info) {
  return <DeleteEntity key={keyOf(info, 'delete')} info={info} />
}

export function duplicateAction(info) {
  return <DuplicateEntity key={keyOf(info, 'duplicate')} info={info} />
}

export function duplicateWithNameAction(info) {
  return <DuplicateEntityWithName key={keyOf(info, 'duplicate')} info={info} />
}

export function defaultColumn(field, header = field, formatter = info => info.getValue(), options = {}) {
  return column.accessor(field, {
    cell: formatter,
    header: _.capitalize(header),
    ...options,
  })
}

export function defaultColumnId(props = {}) {
  return column.accessor('id', {
    cell: info => info.getValue(),
    header: '#',
    ...props,
  })
}

export function defaultActionsColumn(...actionsList) {
  return column.accessor('action', {
    enableSorting: false,
    enableColumnResize: false,
    cell: actions(...actionsList),
    header: '',
    initialSize: `max-w-[${actionsList.length * 10}px] w-[${actionsList.length * 10}px]`,
  })
}

export function defaultActiveColumn(activeToggleFormatter = toggleFormatter) {
  return defaultColumn('active', 'Active', activeToggleFormatter, { initialSize: 'w-18', enableColumnResize: false })
}

export default column
